module.exports = __webpack_public_path__ + "static/media/nenglifen3.2b2ed975.jpg";